import { configService, LoggerService } from '@umanforge/common';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface LinkToAppProps {
  appKey: string;
  icon: React.ElementType;
}

const LinkToApp: React.FC<LinkToAppProps> = ( { appKey, icon: Icon } ) => {
  const [ url, setUrl ] = useState<string>( '#' );
  const { t } = useTranslation();
  const logger: LoggerService = new LoggerService( 'LinkToApp' );

  useEffect( () => {
    const fetchUrl = async () => {
      const fullConfigKey = `REACT_APP_${appKey}_BASE_URL`;
      try {
        const resolvedUrl = await configService.getConfigValue( fullConfigKey, process.env[ fullConfigKey ] || '' );
        if ( resolvedUrl ) {
          setUrl( resolvedUrl );
        }
      } catch ( error ) {
        logger.error( `Failed to fetch the URL for ${fullConfigKey}:`, error );
      }
    };

    fetchUrl();
  }, [ appKey ] );

  // html
  return (
    <a href={url} rel="noopener noreferrer" className='p-2 rounded-md hover:bg-gray-100 flex items-center gap-2' onClick={ e => { e.stopPropagation(); } }>
      <Icon />
      { t( 'common:apps.' + appKey.toLowerCase() ) }
    </a>
  );
};

export { LinkToApp };